(function () {
  function getTabs(root) {
    return Array.from(root.querySelectorAll('.tabbedGroup__tab[role="tab"]'));
  }

  function getPanels(root) {
    return Array.from(root.querySelectorAll('.tabbedGroup__panel[role="tabpanel"]'));
  }

  function triggerRevealAnimations(panelEl) {
    if (!panelEl) return;

    panelEl.querySelectorAll('animation-reveal').forEach((el) => {
      if (typeof el.animateImageTxt === 'function') {
        el.animateImageTxt();
      }
    });
  }

  function scrollTabIntoView(root, key) {
    const activeTab = root.querySelector(`.tabbedGroup__tab[data-tab-key="${key}"]`);
    if (!activeTab) return;

    if (window.matchMedia('(max-width: 989px)').matches) {
      activeTab.scrollIntoView({
        behavior: 'smooth',
        inline: 'start',
        block: 'nearest'
      });
    }
  }

  function setActive(root, key, focusTab, shouldScroll = true) {
    const tabs = getTabs(root);
    const panels = getPanels(root);

    tabs.forEach((tab) => {
      const isActive = tab.getAttribute('data-tab-key') === key;
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.classList.toggle('is-active', isActive);
      if (isActive && focusTab) tab.focus();
    });

    let activePanel = null;
    panels.forEach((panel) => {
      const isActive = panel.getAttribute('data-tab-panel') === key;
      panel.hidden = !isActive;
      if (isActive) activePanel = panel;
    });

    if (shouldScroll) {
  scrollTabIntoView(root, key);
}

    window.requestAnimationFrame(() => triggerRevealAnimations(activePanel));
  }

  function init(root) {
    const tabs = getTabs(root);
    if (!tabs.length) return;

    const initiallyActive =
      tabs.find((t) => t.getAttribute('aria-selected') === 'true') || tabs[0];

    setActive(
  root,
  initiallyActive.getAttribute('data-tab-key'),
  false,
  false
);

    tabs.forEach((tab, idx) => {
      tab.addEventListener('click', () => {
        setActive(root, tab.getAttribute('data-tab-key'), false);
      });

      tab.addEventListener('keydown', (e) => {
        const key = e.key;
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(key)) return;

        e.preventDefault();

        let nextIndex = idx;
        if (key === 'ArrowRight') nextIndex = (idx + 1) % tabs.length;
        if (key === 'ArrowLeft') nextIndex = (idx - 1 + tabs.length) % tabs.length;
        if (key === 'Home') nextIndex = 0;
        if (key === 'End') nextIndex = tabs.length - 1;

        const nextTab = tabs[nextIndex];
        setActive(root, nextTab.getAttribute('data-tab-key'), true);
      });
    });
  }

  function openTabFromTrigger(tabKey) {
    const firstTabbedGroup = document.querySelector('[data-tabbed-group]');
    if (!firstTabbedGroup || !tabKey) return;

    setActive(firstTabbedGroup, tabKey, false);

    const activePanel = firstTabbedGroup.querySelector(`.tabbedGroup__panel[data-tab-panel="${tabKey}"]`);

    if (activePanel) {
      activePanel.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    } else {
      firstTabbedGroup.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-tabbed-group]').forEach(init);
  });

    function handleExternalTabTriggers(event) {
    const manualTrigger = event.target.closest('[data-open-tabbed-group-tab]');

    if (manualTrigger) {
      event.preventDefault();
      event.stopPropagation();

      const tabKey = manualTrigger.getAttribute('data-open-tabbed-group-tab');
      openTabFromTrigger(tabKey);
      return;
    }

    const judgeMeTrigger = event.target.closest('.jdgm-preview-badge');

    // Only hijack Judge.me's PDP badge when this page actually contains
    // Amino Z's tabbed Reviews panel. Collection/product-card badges should
    // retain their normal link behaviour.
    if (judgeMeTrigger && document.querySelector('[data-tabbed-group] [data-tab-panel="reviews"]')) {
      event.preventDefault();
      event.stopPropagation();
      openTabFromTrigger('reviews');
    }
  }

  function handleExternalTabKeydown(event) {
    const judgeMeTrigger = event.target.closest('.jdgm-preview-badge');

    if (!judgeMeTrigger) return;
    if (!document.querySelector('[data-tabbed-group] [data-tab-panel="reviews"]')) return;
    if (event.key !== 'Enter' && event.key !== ' ') return;

    event.preventDefault();
    event.stopPropagation();
    openTabFromTrigger('reviews');
  }

  document.addEventListener('click', handleExternalTabTriggers, true);
  document.addEventListener('keydown', handleExternalTabKeydown, true);
})();